import { PartialTranslation } from '../translations';

export const nl: PartialTranslation = {
  newChat: 'Nieuwe chat',
  search: 'Zoeken',
  user: 'Gebruiker',
  settings: 'Instellingen',
  language: 'Taal',
  getHelp: 'Hulp krijgen',
  viewAllPlans: 'Alle plannen bekijken',
  learnMore: 'Meer leren',
  logOut: 'Uitloggen',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Automatische detectie',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Vraag alles',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Persoonlijk',
  freePlan: 'Gratis plan',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'Bronnen',
  addResource: 'Bron toevoegen',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Typ een bericht...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Bijlage toevoegen',
  sendMessage: 'Bericht verzenden',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译
  login: 'Inloggen',
  register: 'Registreren',
  welcomeBack: 'Welkom bij LawHelper',
  loginSubtitle: 'Uw AI Juridisch Onderzoeksassistent',
  continueWithGoogle: 'Doorgaan met Google',
  continueWithMicrosoft: 'Doorgaan met Microsoft',
  continueWithWeChat: 'Doorgaan met WeChat',
  orContinueWith: 'of doorgaan met',
  emailTab: 'E-mail',
  phoneTab: 'Telefoon',
  emailPlaceholder: 'Voer uw e-mail in',
  phonePlaceholder: 'Voer telefoonnummer in',
  codePlaceholder: 'Voer 6-cijferige code in',
  sending: 'Bezig met verzenden...',
  verifying: 'Bezig met verifiëren...',
  verify: 'Verifiëren',
  sendMagicLink: 'Magische link verzenden',
  getVerificationCode: 'Code ophalen',
  resendCode: 'Code opnieuw verzenden',
  resendIn: 'Opnieuw verzenden over',
  magicLinkSent: 'Magische link verzonden naar uw e-mail',
  magicLinkHint: 'We sturen een beveiligde link naar uw e-mail',
  otpSent: 'Verificatiecode verzonden',
  agreeToTerms: 'Door verder te gaan, gaat u akkoord met onze',
  privacyPolicy: 'Privacybeleid',
  termsOfService: 'Servicevoorwaarden',
  and: 'en',
  privacyTitle: 'Uw privacy is belangrijk',
  privacyIntro: 'We gebruiken cookies en vergelijkbare technologieën om u de beste ervaring te bieden.',
  essentialCookies: 'Essentiële cookies',
  essentialDesc: 'Nodig voor de werking van de website',
  analyticsCookies: 'Analytische cookies',
  analyticsDesc: 'Helpen ons onze service te verbeteren',
  marketingCookies: 'Marketing cookies',
  marketingDesc: 'Gebruikt voor gepersonaliseerde content',
  acceptAll: 'Alles accepteren',
  essentialOnly: 'Alleen essentieel',
  customize: 'Aanpassen',
  savePreferences: 'Voorkeuren opslaan',
  back: 'Terug',
  readPrivacyPolicy: 'Lees ons privacybeleid',
  cookiePolicy: 'Cookiebeleid',
  gdprCompliance: 'AVG',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI Review',
  aiDraft: 'AI Opstellen',
  smartAssistant: 'Sjabloon',

  // 知识库搜索
  enableKnowledgeSearch: 'Zoeken activeren',
  knowledgeSearchDesc: 'AI zoekt in uw documenten',
  clickToDisable: 'Uitschakelen',
  clickToEnable: 'Inschakelen',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Bronpaneel sluiten',
  uploading: '%{fileName} uploaden...',
  processing: '%{fileName} verwerken...',
  uploadSuccess: '✓ %{fileName} geüpload',
  uploadError: '✗ Upload mislukt: %{error}',
  quickAnswer: 'Snel antwoord',
  quickAnswerDesc: 'Snel antwoord op eenvoudige vragen',
  cancelRequest: 'Annuleren',
  library: 'Bibliotheek',
  filterAll: 'Alles',
  filterChat: 'Chats',
  filterReview: 'Beoordeling',
  filterDraft: 'Concept',
  filterTemplate: 'Sjabloon',
  filterForm: 'Formulier',
  thinking: 'Aan het denken...',
  thinkingProcess: 'Denkproces',
  analyzingLegalLogic: 'Juridische logica analyseren...',
  lawhelperThinking: 'Lawhelper denkt na...',
  serviceError: 'Servicefout',
  uploaded: 'Geüpload',
  settingsGeneral: 'Algemeen',
  settingsNotifications: 'Meldingen',
  settingsAppearance: 'Weergave',
  settingsProfile: 'Profiel',
  settingsResponseNotifications: 'Antwoordmeldingen',
  settingsResponseNotificationsDesc: 'Melding wanneer AI klaar is met antwoorden',
  settingsColorMode: 'Kleurmodus',
  settingsLight: 'Licht',
  settingsDark: 'Donker',
  settingsSystem: 'Systeem',
  about: 'Over',
  reviewTitle: 'Documentbeoordeling',
  exitReview: 'Beoordeling verlaten',
  uploadPrompt: 'Upload PDF om beoordeling te starten',
  uploadButton: 'Bestand selecteren',
  startChatConfig: 'Typ "Dit document beoordelen" om te starten',
  reviewPlaceholder: 'Typ een bericht of "Dit document beoordelen"...',
  analyzing: 'Beoordelen...',
  reviewComplete: 'Beoordeling voltooid',
  issuesFound: '%{count} problemen gevonden',
  draftTitle: 'Juridisch document opstellen',
  draftPlaceholder: 'Bewerk hier of laat AI genereren...',
  analyzingTemplate: 'Sjabloon %{name} analyseren...',
  templateAnalyzed: '✅ Sjabloon %{name} geanalyseerd! Hoe wilt u het wijzigen?',
  templateAnalysisPrompt: 'Belangrijkste clausules van sjabloon analyseren',
  parsingFailed: '⚠️ Bestand kon niet worden geanalyseerd, maar u kunt uw behoeften beschrijven.',
  generating: 'Genereren...',
  generatedSuccess: '✅ Document gegenereerd! Bekijk en bewerk in de editor.',
  drafterWelcome: 'Welkom bij de AI-documentassistent',
  drafterYouCan: 'U kunt:',
  drafterUploadTemplate: 'Sjabloon uploaden voor AI-analyse',
  drafterDescribeNeeds: 'Documentvereisten beschrijven',
  drafterLetAiHelp: 'AI helpt bij het opstellen van contracten, overeenkomsten, enz.',
  drafterExamples: 'Voorbeelden:',
  drafterExampleRental: '"Stel een huurcontract op"',
  drafterExampleLabor: '"Vul het arbeidscontract in volgens sjabloon"',
  drafterInputPlaceholder: 'Beschrijf uw documentbehoeften...',
  drafterThinking: 'Aan het denken...',
  drafterHistoryTitle: 'Geschiedenis',
  drafterNoHistory: 'Geen geschiedenis',
  drafterNewChat: 'Nieuwe chat',
  drafterHistory: 'Geschiedenis',
  drafterRemoveAttachment: 'Bijlage verwijderen',
  drafterLineHeight: 'Regelhoogte',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exporteren als Word (.docx)',
  drafterExportPdf: 'Exporteren als PDF',
  drafterSave: 'Document opslaan',
  drafterDownload: 'Document downloaden',
  drafterUndo: 'Ongedaan maken',
  drafterRedo: 'Opnieuw',
  drafterBold: 'Vet',
  drafterItalic: 'Cursief',
  drafterStrike: 'Doorhalen',
  drafterUnderline: 'Onderstrepen',
  drafterHighlight: 'Markeren',
  drafterLink: 'Link invoegen',
  drafterAlignLeft: 'Links uitlijnen',
  drafterAlignCenter: 'Centreren',
  drafterAlignRight: 'Rechts uitlijnen',
  drafterAlignJustify: 'Uitvullen',
  drafterList: 'Lijst',
  drafterBulletList: 'Opsommingstekens',
  drafterOrderedList: 'Genummerde lijst',
  drafterTaskList: 'Takenlijst',
  drafterOpenResource: 'Bronpaneel openen',
  drafterStopGeneration: 'Generatie stoppen',
  drafterAgentMode: 'Agentmodus actief | Klik voor normale chat',
  drafterAgentModeOn: 'Agentmodus actief | Klik voor normale chat',
  drafterAgentModeOff: 'Normale chatmodus | Klik voor agentmodus',
  drafterUploadAttachment: 'Bijlage uploaden',
  drafterExit: 'Afsluiten',
  drafterConfirm: 'Bevestigen',
  drafterOpenLink: 'Link openen',
  drafterDeleteLink: 'Link verwijderen',
  drafterQuote: 'Citaat',
  workflowTitle: 'AI-workflow',
  workflowRunning: 'Wordt uitgevoerd...',
  workflowReady: 'Gereed',
  workflowCompleted: 'Voltooid',
  workflowStartFailed: 'Workflow starten mislukt',
  workflowExecutionFailed: 'Workflow uitvoering mislukt',
  workflowInterrupted: 'Workflow onderbroken',
  workflowProcessing: 'Verwerken...',
  workflowStepsCompleted: 'stappen voltooid',
  workflowStepsTotal: 'Workflow voltooid (%{count} stappen)',
  acceptChanges: 'Wijzigingen accepteren',
  rejectChanges: 'Wijzigingen afwijzen',
  changesAccepted: 'Wijzigingen geaccepteerd',
  changesRejected: 'Wijzigingen afgewezen',
  stopWorkflow: 'Stoppen',
  restartWorkflow: 'Herstarten',
  startDrafting: 'Opstellen starten',
  interrupt: 'Stoppen',
  documentSubject: 'Documentonderwerp *',
  documentType: 'Documenttype',
  jurisdiction: 'Jurisdictie',
  specialRequirements: 'Speciale vereisten (optioneel)',
  clickStartDrafting: 'Klik "Opstellen starten" om de workflow te starten',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Overeenkomst',
  docTypeNotice: 'Kennisgeving',
  docTypeLetter: 'Brief',
  docTypePetition: 'Verzoekschrift',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Volmacht',
  countryChina: 'China',
  countryUSA: 'Verenigde Staten',
  countryGermany: 'Duitsland',
  countryJapan: 'Japan',
  countryFrance: 'Frankrijk',
  countryUK: 'Verenigd Koninkrijk',
  citationVerified: 'Geverifieerd',
  citationUnverified: 'Niet geverifieerd',
  imageLoadFailed: 'Afbeelding laden mislukt',
  smartDocTitle: 'Slim documentassistent',
  smartDocChatTitle: 'AI-documentassistent',
  smartDocDropPrompt: 'Sleep PDF-bestand hierheen',
  smartDocSelectFile: 'Bestand selecteren',
  smartDocOr: 'of',
  smartDocWelcomeTitle: 'Welkom bij de AI-documentassistent',
  smartDocWelcomeYouCan: 'U kunt:',
  smartDocUploadForAI: 'Sjabloon uploaden voor AI-analyse',
  smartDocDescribeDoc: 'Documentvereisten beschrijven',
  smartDocLetAIDraft: 'AI helpt bij het opstellen van contracten',
  smartDocExamples: 'Voorbeelden:',
  smartDocExampleRental: '"Stel een huurcontract op"',
  smartDocExampleLabor: '"Vul het arbeidscontract in"',
  smartDocInputPlaceholder: 'Beschrijf uw documentbehoeften...',
  smartDocRemoveAttachment: 'Bijlage verwijderen',
  smartDocOpenResources: 'Bronpaneel openen',
  smartDocExit: 'Afsluiten',
  reviewStartFailed: 'Beoordelingsworkflow starten mislukt',
  reviewFailed: 'Beoordeling mislukt',
  reviewFoundIssues: 'Beoordeling voltooid, %{count} problemen gevonden.',
  cannotReadStream: 'Kan antwoordstroom niet lezen',
  parseEventFailed: 'Workflow-gebeurtenis analyseren mislukt',
  errorPrefix: 'Fout',
  unknownError: 'Onbekende fout',
  file: 'Bestand',
  loading: 'Laden...',
  localFolders: 'Lokale mappen',
  selectLocalFolder: 'Lokale map selecteren',
  reselectFolder: 'Map wijzigen',
  addToContext: 'Toevoegen aan chat',
  saveFile: 'Opslaan',
  renameFile: 'Hernoemen',
  fileSaved: 'Bestand opgeslagen',
  fileRenamed: 'Bestand hernoemd naar %{name}',
  browserNotSupported: 'Uw browser ondersteunt geen lokale maptoegang',
  noFolderSelected: 'Selecteer een lokale map om bestanden te bladeren',
  scanningFolder: 'Map scannen...',
  selectFileToPreview: 'Selecteer een bestand voor voorbeeld',
  aiAnalyze: 'AI-analyse',
};
